import routes from 'routes/user'


const User = () => routes

export default User
